import ncl from "@public/images/ncl-img.png";
import ttln from "@public/images/ttln-img.png";
import tml from "@public/images/tml-img.png";

const DATA_MOCKUP = [
  {
    key: 1,
    name: "Nguyễn Cửu Long",
    position: "Founder of Be Rich Club Author of Diamond, Be Rich & Unicorn",
    image: ncl,
    quote: "Bạn là một vì sao, nhiệm vụ của bạn là toả sáng",
  },
  {
    key: 2,
    name: "Trần Thị Lan Nhi",
    position: "Co-Founder of Bliss Education Training Director of BeU",
    image: ttln,
    quote: "If you can dream it, you can do it",
  },
  {
    key: 3,
    name: "Trần Minh Lân",
    position: "Co-Founder of Bliss Unicorn Solution CEO of B.U.S",
    image: tml,
    quote: "Do or Don't Do. There is NO try",
  },
];

export { DATA_MOCKUP };
